import { Activity, ActivityType } from 'app/shared/features/activity-selector/models';
import { MeasurementType } from 'app/shared/models';

function isPackingActivity(activity: Activity | undefined) {
    if (!activity) return false;
    return activity.activityType === ActivityType.Packing;
}

export function isContainerMeasurementWeight(activity: Activity | undefined) {
    if (!activity) return false;
    return activity.measurementType === MeasurementType.containerWeight;
}

export function isContainerMeasurementProductBoxes(activity: Activity | undefined) {
    if (!activity) return false;
    return activity.measurementType === MeasurementType.containerProductBoxes;
}
// container measurement activity is a packing activity with measurement type
export function isResultRegistrationActivity(activity: Activity | undefined) {
    return (
        isPackingActivity(activity) &&
        (isContainerMeasurementWeight(activity) || isContainerMeasurementProductBoxes(activity))
    );
}
